<app-layout-core-splashscreen></app-layout-core-splashscreen>
<router-outlet></router-outlet>